<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <modal-select modal="dsr-modal" name="dsr_id" :readonly="item.id>0" :item-id="item.dsr_id" :item-name="item.dsr?item.dsr.data.name:''" v-on:select-item="selectDsr"  :state="validateState('dsr_id')" placeholder="Criado por" label="Criado por" ></modal-select>
          <modal-select modal="dsr-modal" name="change_dsr_id" :readonly="item.id>0" :item-id="item.change_dsr_id" :item-name="item.changedsr?item.changedsr.data.name:''" v-on:select-item="selectDsr"  :state="validateState('change_dsr_id')" placeholder="DSR a Alterar" label="DSR a Alterar" ></modal-select>
          <modal-select modal="dsr-modal" name="leader_id" :readonly="item.id>0" :item-id="item.leader_id" :item-name="item.leader?item.leader.data.name:''" v-on:select-item="selectDsr"  :state="validateState('leader_id')" placeholder="Leader" label="Leader" ></modal-select>

          <b-form-row>
            <b-col md="4">
              <b-form-group label="Estado">
                <b-form-select :options="lists.formStates" name="state" v-model="item.state" placeholder="Estado"  :state="validateState('state')" ></b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('state') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Tipo DSR">
                <b-form-select :options="lists.dsrTypes" name="dsr_type" v-model="item.dsr_type" placeholder="Estado"  :state="validateState('dsr_type')" ></b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('dsr_type') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Tipo Alteração">
                <b-form-select :options="lists.formAlterationTypes" name="alteration_type" v-model="item.alteration_type" placeholder="Estado"  :state="validateState('alteration_type')" ></b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('alteration_type') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col md="6">
              <b-form-group label="Inicio">
                <b-form-select :options="lists.months" name="ym_start" v-model="item.ym_start" placeholder="Inicio"  :state="validateState('ym_start')" ></b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('ym_start') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Fim">
                <b-form-select :options="lists.months" name="ym_end" v-model="item.ym_end" placeholder="Fim"  :state="validateState('ym_end')" ></b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('ym_end') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col md="6">
              <b-form-group label="Nome">
                <b-form-input type="text"  name="first_name" v-model="item.first_name" placeholder="Nome"  :state="validateState('first_name')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('first_name') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Apelido">
                <b-form-input type="text"  name="last_name" v-model="item.last_name" placeholder="Apelido"  :state="validateState('last_name')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('last_name') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col md="6">
              <b-form-group label="Email">
                <b-form-input type="text"  name="email" v-model="item.email" placeholder="Email"  :state="validateState('email')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('email') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Telefone">
                <b-form-input type="text"  name="phone" v-model="item.phone" placeholder="Telefone"  :state="validateState('phone')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('phone') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col md="6">
              <b-form-group label="Data Nascimento">
                <b-form-input type="text"  name="birth_date" v-model="item.birth_date" placeholder="Data Nascimento"  :state="validateState('birth_date')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('birth_date') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Código">
                <b-form-input type="text"  name="code" v-model="item.code" placeholder="Código"  :state="validateState('code')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-group label="Notas">
            <b-form-textarea type="text"  name="notes" v-model="item.notes" placeholder="Notas"  :state="validateState('notes')"></b-form-textarea>
            <b-form-invalid-feedback>
              {{ errors.first('notes') }}
            </b-form-invalid-feedback>
          </b-form-group>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'siteregistrations.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Equipa </strong>
          </div>
          <h6>DSR</h6>
          <div v-for="(dsr, index) in item.team_members">
            {{ dsr.id }} - {{ dsr.first_name }} {{ dsr.last_name }}
          </div>
          <h6 class="mt-5">ID DSR</h6>
          <div v-for="(dsr, index) in item.team">
            {{ dsr }}
          </div>
        </b-card>
      </b-col>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>

import lists from '@/components/States'
export default {
  name: 'BestofDsrObjectiveEdit',
  props: ['id'],
  components: { },
  data() {
    return {
      lists: lists,
      dataLoaded: false,
      modalType: '',
      showModal: false,
      item: {
        zone: '',
        campaign: {
          data: {
            id: null,
            name: ''
          }
        },
        dsr: {
          data: {
            name: '',
            id: null
          }
        },
        value: 0,
        quantity: 0,
        operators: 0
      }
    }
  },
  methods: {
    selectDsr(e) {
      this.item.dsr_id = e.item.id
      this.item.dsr.data = e.item
    },
    selectCampaign(e) {
      this.item.campaign_id = e.item.id
      this.item.campaign.data = e.item
    },
    selectZone(e) {
      this.item.zone = e.item.zone
    },
    doShowModal(type) {
      this.modalType = type
      this.$refs.dealersModal.show()
    },
    hideModal() {
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('siteregistrations' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'siteregistrations.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('siteregistrations', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'siteregistrations.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('siteregistrations' + '/' + id)
        .then(response => {
          this.item = response.data.data
          if(!this.item.dsr) {
            this.item.dsr = { data: {} }
          }
          if(!this.item.leader) {
            this.item.leader = { data: {} }
          }
          if(!this.item.changedsr) {
            this.item.changedsr = { data: {} }
          }
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'siteregistrations.index'
          })
        })
    } else {
      this.dataLoaded =true
    }
  }
}
</script>
